<template lang="pug">
  .status(:class="`status--${status}`")
    | {{ `status.${status}` | translate }}
</template>

<script>
export default {
  name: 'StatusLabel',

  props: {
    status: String
  }
}
</script>

<style lang="scss" scoped>
  .status {
    width: 100%;
    font-size: 1.4rem;
    position: relative;
    padding-left: 2.2rem;
    margin-right: 3.5rem;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }

    &--waited::after {
      background: #FF6158;
    }

    &--in_process::after {
      background: #F9CD13;
    }

    &--loaded::after {
      background: #1DA643;
    }

    &--out_process::after {
      background: #e5fb19;
    }

    &--uploaded::after {
      background: #006DF0;
    }
  }
</style>
